<script setup>
import { getCurrentInstance, nextTick, onBeforeUnmount, onMounted } from 'vue';
import { hydrateMfComponents } from './hydrate-mf-components';

const props = defineProps({
    targetSelector: { type: String, required: true },
    containerRef: { type: String, default: '' },
    mediaEntryMap: { type: Object, default: () => ({}) },
});

const currentInstance = getCurrentInstance();
let cleanupHydratedContent = null;

const hydrate = async () => {
    await nextTick();

    cleanupHydratedContent?.();

    cleanupHydratedContent = hydrateMfComponents(document.querySelector(props.targetSelector), {
        appContext: currentInstance?.appContext,
        containerRef: props.containerRef,
        mediaEntryMap: props.mediaEntryMap,
    });
};

onMounted(hydrate);
onBeforeUnmount(() => cleanupHydratedContent?.());
</script>

<template>
    <span hidden aria-hidden="true"></span>
</template>
